// extracted by mini-css-extract-plugin
export default {"fullScreenOverlay":"Loader_fullScreenOverlay__rh-Ie","spinner":"Loader_spinner__wDq1e","spin":"Loader_spin__ddwRw"};